


















import { Component, Vue, Prop } from "vue-property-decorator";

interface DataType {
  rank: Number;
  keyword: String;
  total: Number;
}

@Component({})
export default class Result extends Vue {
  @Prop({ type: Array, default: [] }) data!: Array<DataType>;
}
